import { createContext } from 'react'

export const AppContext = createContext<
  Partial<{
    loaded: boolean
    override: boolean
    screen: DOMRectReadOnly | null
  }>
>({})
